export const clearList = ( list ) => {
	Array.from( list.querySelectorAll( 'li.item' )).forEach( ( it ) => {
		it.remove();
	} );
};